import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import {
  baseInput,
  errorInput,
  errorTableInput,
  tableInput,
  textAreaInput,
} from './text-input.css';

type TextAreaProps = {
  error?: boolean;
  table?: boolean;
  css?: React.CSSProperties;
} & ComponentPropsWithRef<'textarea'>;

export const TextArea = ({ error = false, table = false, css, ref, ...props }: TextAreaProps) => {
  const errorType = error ? errorInput : '';
  const errorTableType = error && table ? errorTableInput : '';
  const tableType = table ? tableInput : '';

  return (
    <textarea
      ref={ref}
      style={css}
      className={clsx(baseInput, errorType, tableType, errorTableType, textAreaInput)}
      {...props}
    />
  );
};
